// extracted by mini-css-extract-plugin
module.exports = {"drawerBackdrop":"Drawer_drawerBackdrop__SEgk2","open":"Drawer_open__803_K","drawerContent":"Drawer_drawerContent__iRmFK","drawerBody":"Drawer_drawerBody__cz4Vv"};